import createClient from 'openapi-fetch';

import { apiOrigin } from './api-url';
import { authFetch } from './auth-fetch';
import { ApiError, NETWORK_ERROR } from './errors';
import type { paths } from './schema.gen';

/**
 * 파트너 API 클라이언트 — 경로·파라미터·응답 타입은 OpenAPI 명세(schema.gen.ts)에서 온다.
 * 명세 경로에 /api 가 포함돼 있어 baseUrl 은 출처(origin)만 둔다 (비우면 같은 출처).
 */
export const api = createClient<paths>({
  baseUrl: apiOrigin(),
  fetch: authFetch,
});

type FetchResult<T> = { data?: T; error?: unknown; response: Response };

/**
 * openapi-fetch 결과를 값 또는 ApiError 로 바꾼다 — TanStack Query 의 queryFn·mutationFn 이 이 형태를 쓴다.
 * @throws ApiError 서버 오류 응답(코드 포함) 또는 네트워크 오류(NETWORK_ERROR)
 */
export async function unwrap<T>(request: Promise<FetchResult<T>>): Promise<T> {
  let result: FetchResult<T>;
  try {
    result = await request;
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') throw error;
    throw new ApiError({ status: 0, code: NETWORK_ERROR });
  }
  if (!result.response.ok) {
    throw ApiError.fromResponse(result.response, result.error);
  }
  return result.data as T;
}
